import React, { useState } from 'react'
import { Box, Tooltip, IconButton, TableCell, TableRow } from '@mui/material'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Delete from './Delete'
import Form from './Form'
import { usePatchCompanyMapping } from '../../api/company-mapping'

const Row = ({ data, refetch }) => {
  const [editing, setEditing] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)

  return (
    <>
      <TableRow style={{ borderBottom: 'unset' }}>
        <TableCell>{data.companyName}</TableCell>
        <TableCell>{data.ekt}</TableCell>
        <TableCell>{data.hwt}</TableCell>
        <TableCell> {data.hte}</TableCell>
        <TableCell>{data.htl}</TableCell>
        <TableCell>{data.htb}</TableCell>
        <TableCell align='right'>
          <Box display='flex' justifyContent='space-evenly'>
            <Tooltip title='Edit'>
              <IconButton onClick={() => setEditing(true)}>
                <EditOutlinedIcon size='small' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton onClick={() => setOpenDelete(true)}>
                <DeleteOutlinedIcon size='small' />
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
      <Form
        key={data.updatedAt}
        defaultValues={data}
        open={editing}
        setOpen={setEditing}
        api={usePatchCompanyMapping}
        refetch={refetch}
      />
    </>
  )
}

export default Row
